<template>
    <v-container>
        <h1 class="text-h4 mb-4">Yeni Duyuru Oluştur</h1>
        <v-card>
            <v-card-text>
                <v-alert v-if="error" type="error" dense dismissible class="mb-4">
                    {{ error }}
                </v-alert>
                <v-form @submit.prevent="handleSubmit" ref="announcementForm">
                    <v-text-field v-model="formData.title" label="Başlık" required :rules="[rules.required]"
                        counter="100" class="mb-3"></v-text-field>

                    <v-textarea v-model="formData.description" label="Açıklama" required :rules="[rules.required]"
                        rows="5" auto-grow class="mb-3"></v-textarea>

                    <v-text-field v-model="formData.price" label="Fiyat (Opsiyonel)" type="number" prefix="₺"
                        :rules="[rules.numeric]" clearable class="mb-3"></v-text-field>

                    <v-text-field v-model="formData.location" label="Konum (Opsiyonel)" placeholder="Şehir, İlçe"
                        class="mb-3"></v-text-field>

                    <v-text-field v-model="formData.contact_info" label="İletişim Bilgisi (Opsiyonel)"
                        placeholder="Telefon veya E-posta" class="mb-3"></v-text-field>

                    <v-file-input v-model="transientImageFiles" @update:modelValue="handleFileChange"
                        label="Resim Ekle (Maks 5)" multiple chips show-size accept="image/*" prepend-icon="mdi-camera"
                        :rules="[rules.maxAccumulatedImages]" class="mb-3"></v-file-input>

                    <v-row v-if="imagePreviews.length > 0">
                        <v-col v-for="(src, index) in imagePreviews" :key="index" cols="6" sm="4" md="3" lg="2">
                            <v-img :src="src" aspect-ratio="1" class="grey lighten-2">
                                <v-btn icon="mdi-close" size="x-small" color="red" class="ma-1" absolute right top
                                    @click="removeImage(index)"></v-btn>
                            </v-img>
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <v-btn type="submit" color="primary" large :loading="loading" :disabled="loading">
                        Duyuruyu Yayınla
                    </v-btn>
                    <v-btn text @click="$router.go(-1)" class="ml-2">İptal</v-btn>

                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import announcementService from '@/services/announcementService';

export default {
    name: 'AnnouncementCreate',
    data() {
        return {
            loading: false,
            error: null,
            formData: {
                title: '',
                description: '',
                price: null,
                location: '',
                contact_info: '',
            },
            transientImageFiles: [], // v-file-input için geçici model
            accumulatedFiles: [],   // Biriktirilen asıl dosyalar
            imagePreviews: [],      // Önizleme için { src: '...', name: '...' } listesi
            maxFiles: 5,            // Maksimum dosya sayısı
            rules: {
                required: value => !!value || 'Bu alan zorunludur.',
                numeric: value => (!value || value === '' || !isNaN(parseFloat(value))) || 'Sayısal bir değer veya boş olmalı.',
                // Kuralı birikmiş dosya sayısına göre kontrol et
                maxAccumulatedImages: () => this.accumulatedFiles.length <= this.maxFiles || `En fazla ${this.maxFiles} resim yükleyebilirsiniz.`
            },
        };
    },
    methods: {
        async handleSubmit() {
            this.error = null;
            // Formu doğrula (maxAccumulatedImages kuralı da kontrol edilir)
            const { valid } = await this.$refs.announcementForm.validate();
            if (!valid) return;
            // Maksimum dosya sayısını tekrar kontrol et (güvenlik için)
            if (this.accumulatedFiles.length > this.maxFiles) {
                this.error = `En fazla ${this.maxFiles} resim yükleyebilirsiniz.`;
                return;
            }


            this.loading = true;
            try {
                // 1. Metin verileriyle ilanı oluştur
                const announcementData = { ...this.formData };
                if (announcementData.price === '') announcementData.price = null;
                else if (announcementData.price !== null) announcementData.price = parseFloat(announcementData.price);

                const response = await announcementService.createAnnouncement(announcementData);
                const createdAnnouncementId = response.data.id;

                // 2. Birikmiş resimler varsa yükle
                if (this.accumulatedFiles.length > 0) {
                    const imageFormData = new FormData();
                    this.accumulatedFiles.forEach(file => {
                        imageFormData.append('images', file); // Backend'in beklediği alan adı 'images'
                    });
                    await announcementService.uploadImages(createdAnnouncementId, imageFormData);
                }

                // Başarılı, oluşturulan ilanın detay sayfasına yönlendir
                this.$router.push({ name: 'AnnouncementDetail', params: { id: createdAnnouncementId } });

            } catch (err) {
                this.error = err.response?.data?.message || 'Duyuru oluşturulurken bir hata oluştu.';
                console.error(err);
            } finally {
                this.loading = false;
            }
        },

        // Dosya seçildiğinde tetiklenen metod
        handleFileChange(newlySelectedFiles) {
            if (!newlySelectedFiles || newlySelectedFiles.length === 0) {
                // Eğer seçimi iptal ederse veya boşsa bir şey yapma
                // v-model'i temizleyelim ki aynı dosya tekrar seçilebilsin
                this.transientImageFiles = [];
                return;
            }

            // Yeni seçilen dosyaları birikmiş listeye ekle (limit aşılmadıysa)
            newlySelectedFiles.forEach(file => {
                // Aynı isimli dosya zaten ekli mi diye bak (isteğe bağlı)
                // const alreadyExists = this.accumulatedFiles.some(f => f.name === file.name && f.size === file.size);
                // if (!alreadyExists && this.accumulatedFiles.length < this.maxFiles) {

                // Şimdilik sadece limit kontrolü yapalım
                if (this.accumulatedFiles.length < this.maxFiles) {
                    this.accumulatedFiles.push(file);
                } else {
                    // Limiti aştıysa kullanıcıya bilgi verilebilir (Snackbar vb.)
                    console.warn(`Maksimum ${this.maxFiles} dosya limitine ulaşıldı.`);
                }
            });

            // Önizlemeleri güncelle
            this.updateImagePreviews();

            // v-file-input modelini temizle ki aynı dosyalar tekrar seçilebilsin
            // Not: Doğrudan null yapmak yerine boş dizi atamak daha iyi çalışabilir
            this.$nextTick(() => {
                this.transientImageFiles = [];
            });
        },

        // Birikmiş dosyalara göre önizlemeleri oluştur/güncelle
        updateImagePreviews() {
            this.imagePreviews = []; // Önce temizle
            this.accumulatedFiles.forEach(file => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    // Önizleme listesine src ve dosya adını ekle
                    this.imagePreviews.push({ src: e.target.result, name: file.name });
                };
                reader.onerror = (error) => {
                    console.error("FileReader error: ", error);
                    // Hata durumunda belki bir placeholder eklenebilir
                    this.imagePreviews.push({ src: 'error', name: file.name });
                };
                reader.readAsDataURL(file);
            });
        },

        // Önizlemeden resmi (ve birikmiş dosyayı) kaldır
        removeImage(indexToRemove) {
            if (indexToRemove >= 0 && indexToRemove < this.accumulatedFiles.length) {
                // Hem birikmiş dosyadan hem önizlemeden kaldır
                this.accumulatedFiles.splice(indexToRemove, 1);
                // Önizlemeleri yeniden oluşturmak en kolayı olabilir
                this.updateImagePreviews();
            }
        }
    },
    // Component oluşturulduğunda önizlemeyi güncelle (başlangıçta boş olacak)
    created() {
        this.updateImagePreviews();
    }
};
</script>